import { useRouter } from 'next/router';
import { FC } from 'react';

import { Optional } from '@common/type/CommonTypes';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { LinearProgressStyle } from '@components/store/product/courseReview/style';
import { useCourseReview } from '@hooks/course/courseReview/useCourseReview';

const CourseReviewAverageScore: FC = () => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  const router = useRouter();
  const idName = router.query.idName as Optional<string>;

  const { courseReviewSummaryData, averageRatingTotal } = useCourseReview({ idName });

  const ratings = courseReviewSummaryData?.ratings || [];
  const reviewTotal = courseReviewSummaryData?.count ?? 0;

  const getAverageRating = (totalReviewer: number) => {
    return (totalReviewer * 100) / reviewTotal;
  };

  return (
    <Box>
      <Typography variant="h4">{t('course_detail.course_review.average_score')}</Typography>

      <Box display="flex" alignItems="center" gap={1}>
        <FontAwesomeIcon icon="fa-solid fa-star" style={{ fontSize: 20, color: theme.palette.warning.main }} />
        <Typography variant="h1" component="span" lineHeight="43px">
          {averageRatingTotal}
        </Typography>
        <Typography variant="BaseLegacy" color={theme.palette.textV2.secondary} mt={0.5}>
          ({t('course_detail.course_review.number_review', { review: reviewTotal })})
        </Typography>
      </Box>

      <Box>
        {ratings.map((rating) => (
          <Box key={rating.rating} display="flex" alignItems="center" gap={1}>
            <Typography variant="h6">{rating.rating}</Typography>
            <Box flex={1}>
              <LinearProgressStyle variant="determinate" value={getAverageRating(rating.totalReviewer)} />
            </Box>
            <Typography width={28} variant="BaseLegacy" color={theme.palette.textV2.disabled}>
              {rating.totalReviewer}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CourseReviewAverageScore;
